import { render, staticRenderFns } from "./BillableRateManagementDetailNew.vue?vue&type=template&id=c5a2cb74"
import script from "./BillableRateManagementDetailNew.vue?vue&type=script&lang=js"
export * from "./BillableRateManagementDetailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports